import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HomesliderService } from './../../Services/homeslider.service';
import { MessagePanelService } from './../../Services/message-panel.service';
import { Globals } from './../../global';
import { LocalStorageService } from './../../Services/local-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {

  
  modalRef: BsModalRef;
  public data : any;
  imgbaseurl="";
  defaultImage: any = '';
  imagename: any;
  fileToUpload: File = null;

  constructor(public globals: Globals, private router: Router, private formBuilder: FormBuilder, private messagePanelService: MessagePanelService, private localStorageService: LocalStorageService, public homesliderService:HomesliderService,private modalService: BsModalService) { }


  ngOnInit() {
  }

  onChangeSetImagePath(event){
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        this.imagename = file.name;
        const img = new Image();
        img.src = window.URL.createObjectURL( file );
        this.fileToUpload=file;
        reader.readAsDataURL(file);
        reader.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL( img.src );
          this.defaultImage = reader.result;
      };
    }
  }

  openAddModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }

  openEditModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }
  
  openDeleteModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }

}
